//Importaciones
import React from 'react'
import { useTranslation } from 'react-i18next';
import { Accordion, Card, Col, Row } from 'react-bootstrap';
import { ActionButton, ScrollablePane, ScrollbarVisibility } from '@fluentui/react';
import { useState, useRef } from 'react';
import Message from '../../../../../Common/Message';
import SidePanelAddAction from './SidePanelAddAction';
import PropTypes from 'prop-types';
import ToolBarDownFall from '../../../../sBook/ToolbarDownFall';
import SidePanelViewAllAction from './SidePanelViewAllAction';
import { useBoolean } from '@fluentui/react-hooks';
import DialogUsedCauseWarning from './DialogUsedCauseWarning';

import './style.css'
import { saveCausesByGapId } from '../../../../../../services/sKPI/gap.service';
import GapActionCard from '../GapActionCard/GapActionCard';
import FishboneChart from './FishboneChart';
import { buildCausesChanges } from './causeSelection';
import { useContext } from 'react';
import GapAppContext from '../../../../../../GapAppContext';
import MainAppContext from '../../../../../../MainAppContext';
import SidePanelFishboneSelection from '../../BusinessElementCard/SidePanelFishboneSelection';
import { useGetListGapCausesBoard } from '../../../../../../hooks/services/sKPI/useOfGAP';
import { useEffect } from 'react';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import { _checkSecurityUser } from '../../../../../../common/Helpers/HLP_Security';
import { __enum_PageMode, enum__PRIVILEGES } from '../../../../../../common/Dictionaries';

function Fishbone(props) {
    //Helpers
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextGap = useContext(GapAppContext);

    //Parametros de componente.
    
    const {
        inputParam_GapAnalyzeId = null,
        inputParam_ElementId = null,
        inputParam_GapRevision = null,
        inputParam_RevisionDataserie = null,
        inputParam_FishboneIndex = null,
        inputParam_HasFishbone = false,
        inputParam_DataserieValueChartSelected = null,
        inputParam_CauseList = null,
        inputParam_SetterCauseList = null,
        inputParam_SetFireGetLastActions = null,
    } = props;

    const _priv_canProcessCauses = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, inputParam_RevisionDataserie.elementId, [enum__PRIVILEGES.GAP_CONTRACT_ANALYZE, enum__PRIVILEGES.GAP_CONTRACT_PROPOSE, enum__PRIVILEGES.GAP_CONTRACT_EJECUTE, enum__PRIVILEGES.GAP_CONTRACT_APROVE])
    const _priv_canSelectFishbone = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, inputParam_RevisionDataserie.elementId, [enum__PRIVILEGES.GAP_CONTRACT_ANALYZE, enum__PRIVILEGES.GAP_CONTRACT_PROPOSE, enum__PRIVILEGES.GAP_CONTRACT_EJECUTE, enum__PRIVILEGES.GAP_CONTRACT_APROVE])
    const _priv_canAddAcction = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, inputParam_RevisionDataserie.elementId, [enum__PRIVILEGES.GAP_CONTRACT_ANALYZE, enum__PRIVILEGES.GAP_CONTRACT_PROPOSE, enum__PRIVILEGES.GAP_CONTRACT_EJECUTE, enum__PRIVILEGES.GAP_CONTRACT_APROVE])

    const [isActionPanelOpen, setIsActionPanelOpen] = useState(false);
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [currentSelectedDataserieValueId, setCurrentSelectedDataserieValueId] = useState(inputParam_DataserieValueChartSelected !== null && inputParam_DataserieValueChartSelected !== undefined ? inputParam_DataserieValueChartSelected.id : null);

    const [isViewAllActionPanelOpen, setIsViewAllActionPanelOpen] = useState(false);
    const [causeIdToAddAction, setCauseIdToAddAction] = useState(null);
    const [causeNameToAddAction, setCauseNameToAddAction] = useState(null);


    const [selectedCauses, setSelectedCauses] = useState(inputParam_CauseList.data === null ? inputParam_RevisionDataserie.l_causes : inputParam_CauseList.data);
    

    useEffect(()=> {
        try {
            if (inputParam_CauseList.fireSearch === false) {
                if (inputParam_CauseList.data === null) {
                    setSelectedCauses(inputParam_RevisionDataserie.l_causes)
                }
                else {
                    setSelectedCauses(inputParam_CauseList.data)
                    setCurrentSelectedDataserieValueId(inputParam_DataserieValueChartSelected !== null ? inputParam_DataserieValueChartSelected.id : null)

                    if ((inputParam_DataserieValueChartSelected !== null ? inputParam_DataserieValueChartSelected.id : null) !== currentSelectedDataserieValueId) {
                        setAuxSelectedCauses(null)
                    }
                }
            }
        }
        catch (error) {
        }
    }, [inputParam_CauseList, inputParam_RevisionDataserie]);

    
    const [auxSelectedCauses, setAuxSelectedCauses] = useState(null);
    const [pendingCausesChanges, setPendingCausesChanges] = useState(null);
    const isSavingCausesRef = useRef(false);
    const [isFishboneSelectionPanelOpen, setIsFishboneSelectionPanelOpen] = useState(false);

    useGetListGapCausesBoard(inputParam_GapAnalyzeId, inputParam_RevisionDataserie.elementId, inputParam_DataserieValueChartSelected ? inputParam_DataserieValueChartSelected.id : null, inputParam_CauseList, inputParam_SetterCauseList)

    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);
    const onOpenFishboneSelectionPanel = (e, id) => {
        setIsFishboneSelectionPanelOpen(true)
    };
    const onCloseCausesDialog = () => {
        setPendingCausesChanges(null);
        hideDialog();
    }

    const onReplaceCausesResponse = (replace) => {
        // Un doble clic en "Sí" mandaba el mismo guardado dos veces.
        if (replace && pendingCausesChanges !== null && !isSavingCausesRef.current) {
            isSavingCausesRef.current = true;
            saveCausesByGapId(inputParam_GapAnalyzeId, inputParam_RevisionDataserie.elementId, inputParam_RevisionDataserie.dataserieId, inputParam_GapRevision !== null ? inputParam_GapRevision.id : null, inputParam_DataserieValueChartSelected ? inputParam_DataserieValueChartSelected.id : null , pendingCausesChanges).then((response) => {
                if (response.data.succeeded) {
                    //[##] Aqui revisa. Debes o anexar las causas seleccionadas al objeto correcto o de lo contrario blanquear fishbone y revisiondatalist. (esta en contexto nuevo y como propiedad setter.)
                    response.data.data.forEach(cause => {
                        cause.name = inputParam_RevisionDataserie.l_gap_aef_cause.find(x => x.id === cause.gapAefCauseId).name;
                        cause.gapAefCauseId = inputParam_RevisionDataserie.l_gap_aef_cause.find(x => x.id === cause.gapAefCauseId).id;                        
                    });

                    contextGap.dataserieFullData.value.revisionDataserieFullList.forEach(item => {
                        if (item.gapRevisionId === (inputParam_GapRevision !== null ? inputParam_GapRevision.id : null) && item.gapAnalyzeElementId === inputParam_RevisionDataserie.gapAnalyzeElementId) {
                            item.l_causes = response.data.data
                        }
                    });

                    inputParam_SetterCauseList && inputParam_SetterCauseList({fireSearch: true, data:null})

                    contextGap.dataserieFullData.set(prevState => ({
                        ...prevState,
                        revisionDataserieFullList: contextGap.dataserieFullData.value.revisionDataserieFullList,
                    }));

                    const dataserieExist = contextGap.gapRevisionDataserieList.value.find(x => x.dataserieId === inputParam_RevisionDataserie.dataserieId) !== undefined
                    if (!dataserieExist) {
                        contextGap.gapRevisionDataserieList.set(prevState => ({
                            ...prevState,
                            revisionDataserieFullList:null,
                        }));
                    }

                    
                    contextGap.dataserieFullData.value.revisionDataserieFullList.forEach(dataserie => {
                        dataserie.l_dataserie_vals.forEach(dataserieValue => {
                            if (dataserieValue.id === (inputParam_DataserieValueChartSelected !== null ? inputParam_DataserieValueChartSelected.id : null)) {

                                dataserieValue.colorGap = "yellow";

                            }
                        });
                    });
           
                    contextGap.dataserieFullData.set(contextGap.dataserieFullData.value);

                    setShowMessage(true)
                    setMessageType("success");
                    setMessage(t('data-lang-msg-operationperformed'))
                }
                else {
                    setShowMessage(true)
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                setShowMessage(true)
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            }).finally(() => {
                isSavingCausesRef.current = false;
            });
        }
        setShowMessage(false)
        setAuxSelectedCauses(null);
        setPendingCausesChanges(null);

        hideDialog()
    }

    const onProcessSelectedCausesClick = () => {
        // Causas ya guardadas del período elegido (vienen del tablero de causas). l_causes no sirve para esto:
        // trae solo las del último período con causas y no se actualiza al guardar.
        const dataserieValueId = inputParam_DataserieValueChartSelected ? inputParam_DataserieValueChartSelected.id : null;
        const savedCauses = selectedCauses.filter(x => x.dataserieValueId === dataserieValueId);
        const selectedIds = auxSelectedCauses !== null ? auxSelectedCauses : savedCauses.map(x => x.gapAefCauseId);

        const changes = buildCausesChanges({ savedCauses, selectedIds, gapAnalyzeId: inputParam_GapAnalyzeId });

        if (selectedIds.length === 0) {
            setShowMessage(true)
            setMessageType("warning");
            setMessage(t('data-lang-msg-nocauseselected'))
        }
        else if (changes.length === 0) {
            setShowMessage(true)
            setMessageType("warning");
            setMessage(t('data-lang-msg-nochangesfound'))
        }
        else {
            setPendingCausesChanges(changes)
            showDialog()
        }
    }

    const onOpenActionPanel = () => {
        setIsActionPanelOpen(true)
        //setCauseIdToAddAction(causeId)
        //setCauseNameToAddAction(causeName)
    }

    const onSelectedCauses = (limitExcedded, causes) => {
        setAuxSelectedCauses(causes)
        if (limitExcedded) {
            setShowMessage(true)
            setMessageType("warning");
            setMessage(t('Solo puede seleccionar un máximo de tres causas.'))
        }
    }

    const onRenderCausesContent = (index, item, i) => {
        return <Accordion.Item key={index} eventKey={index} >
                <Accordion.Header>
                    <b>{item.name}</b>
                </Accordion.Header>
                <Accordion.Body className='px-1 py-0'>
                    <Row>
                        <Col className='px-1'>
                            <div>                         
                                <Card.Body className='border-top p-1'>
                                    <div style={{ height: "200px", position: "relative" }}>
                                        <ScrollablePane styles={{contentContainer:{overflowX: "hidden"}}}>
                                            <div>
                                                {
                                                    item.l_action.map((action, index2) => (
                                                        <div data-action-id={action.id}>
                                                            <GapActionCard
                                                                key={index2 + action.id}
                                                                inputParam_GapElementId={inputParam_ElementId}
                                                                inputParam_EditMode={false}
                                                                inputParam_ActionItem={action}
                                                                inputParam_ShowSeparatorStyle={true}
                                                                inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                                                                inputParam_GapRevisionId={inputParam_GapRevision !== null ? inputParam_GapRevision.id : null}
                                                                inputParam_DataserieValueChartSelected={inputParam_DataserieValueChartSelected}
                                                                inputParam_SelectedCauses={selectedCauses}
                                                                inputParam_SetterCauseActionList={setSelectedCauses}
                                                            />
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </ScrollablePane>
                                    </div>
                                </Card.Body>
                            </div>
                        </Col>
                    </Row>
                </Accordion.Body>
        </Accordion.Item>
    }

    const toolBarItems_Actions = {
        items: [
            {
                key: 'openAllActions',
                text: t('data-lang-btn-viewallactions'),
                iconProps: { iconName: 'View' },
                onClick: () => setIsViewAllActionPanelOpen(true),
            },
            {
                key: 'openAddActions',
                text: t('data-lang-btn-addaction'),
                iconProps: { iconName: 'TaskManager' },
                onClick: () => onOpenActionPanel(),
            }
        ].filter(x => ((_priv_canAddAcction.value && _priv_canAddAcction.mode === __enum_PageMode.Edit) && inputParam_RevisionDataserie.fishBone !== null)),
    };

    //Render de componente.
    return  <Row className="h-100">
                <Col xl={9} className="px-0 pe-1 h-100">
                    <Card className='h-100'>
                        {
                            inputParam_FishboneIndex === 0 &&
                            <Card.Header className="card-header-compact">
                                <h5><b>{t('data-lang-lbl-fishbone')}</b></h5>
                            </Card.Header>
                        }
                        <Card.Footer id='btnFishboneType_SelectCauses' className='border-bottom p-0'>
                            <Row>
                                <Col className='my-auto ms-2'>
                                </Col>
                                <Col className='col-auto my-auto'>
                                    <div style={{position: "absolute", display: "contents", width: "100%"}}>
                                        <Message message={ message } display={ showMessage === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
                                    </div>
                                </Col>
                                {
                                    inputParam_HasFishbone && (_priv_canProcessCauses.value && _priv_canProcessCauses.mode === __enum_PageMode.Edit) &&
                                    <Col className='float-end d-flex col-auto'>
                                        <ActionButton
                                            id='btnProcessSelectedCauses'
                                            disabled={!(inputParam_DataserieValueChartSelected && inputParam_DataserieValueChartSelected.gapResult === true)}
                                            iconProps={{ iconName: 'ServerProcesses' }}
                                            onClick={() => onProcessSelectedCausesClick()}
                                            allowDisabledFocus
                                        >
                                            {t('data-lang-btn-processselection')}
                                        </ActionButton>
                                    </Col>
                                }
                                {
                                    inputParam_RevisionDataserie && inputParam_RevisionDataserie.id && !inputParam_HasFishbone && (_priv_canSelectFishbone.value && _priv_canSelectFishbone.mode === __enum_PageMode.Edit) &&
                                    <Col className='col-auto'>
                                        <div className='board-toolbar d-flex float-end'>
                                            <ActionButton iconProps={{ iconName: 'Relationship' }} onClick={() => onOpenFishboneSelectionPanel()} allowDisabledFocus >
                                                {t('data-lang-btn-selectfishbone')}
                                            </ActionButton>
                                        </div>
                                    </Col>
                                }
                            </Row>
                        </Card.Footer>
                        <Card.Body className='h-100 p-1 pt-3'>
                            <Row className='h-100'>
                                {
                                    inputParam_RevisionDataserie.fishBone.objNew !== null &&
                                    <Col>
                                        <FishboneChart
                                            data={ inputParam_RevisionDataserie.fishBone.objNew }
                                            selectedCauses={
                                                currentSelectedDataserieValueId === (inputParam_DataserieValueChartSelected !== null ? inputParam_DataserieValueChartSelected.id : null) ?
                                                (auxSelectedCauses === null ? selectedCauses.map(({ gapAefCauseId }) => gapAefCauseId) : auxSelectedCauses) :
                                                selectedCauses.map(({ gapAefCauseId }) => gapAefCauseId)
                                            }
                                            onSelectCause={onSelectedCauses}
                                        />
                                    </Col>
                                }
                                {
                                    inputParam_RevisionDataserie.fishBone.objNew === null &&
                                    <NoDataLayer display={ true } />
                                }
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xl={3} className='px-0 pe-1'>
                    <Card className='h-100'>
                        {
                            inputParam_FishboneIndex === 0 &&
                            <Card.Header className="card-header-compact">
                                <h5><b>{t('data-lang-lbl-causes')}</b></h5>
                            </Card.Header>
                        }
                        <Card.Footer id='crdCreateActions' className='border-bottom p-0 row m-0'>
                            <Col className='my-auto'>{t('data-lang-lbl-configureactions')}</Col>
                            <Col className='float-end col-auto'>
                                <ToolBarDownFall items={ toolBarItems_Actions } display={ true } mainItem={ { iconName: 'More' } } />
                            </Col>
                        </Card.Footer>
                        <Card.Body className='h-100'>
                            <Row className='h-100'>
                                <Col className='h-100 px-0 pb-0'>
                                    {
                                        selectedCauses.length !== 0 &&
                                        <ScrollablePane
                                                style={{ maxHeight: "100%", height: "100%"}}
                                                styles={{
                                                    root: { position: "relative" },
                                                    contentContainer:{overflowX: "hidden"}
                                                }}
                                                scrollbarVisibility={ScrollbarVisibility.auto}
                                                scrollContainerFocus={true}
                                            >
                                            <Accordion>
                                                {
                                                    selectedCauses.map((item, index) => 
                                                        onRenderCausesContent(index, item)
                                                    )
                                                }
                                            </Accordion>
                                        </ScrollablePane>
                                    }
                                    {
                                        selectedCauses.length === 0 &&
                                        <NoDataLayer display={ true } />
                                    }
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <>
                {
                    selectedCauses !== null && selectedCauses.length > 0 && isActionPanelOpen &&
                    <SidePanelAddAction
                        inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                        inputParam_RevisionDataserie={{l_causes : selectedCauses, elementId: inputParam_ElementId}}
                        inputParam_DataserieValueChartSelected={inputParam_DataserieValueChartSelected}
                        inputParam_CauseName={causeNameToAddAction}
                        inputParam_CauseId={causeIdToAddAction}
                        inputParam_IsPanelOpen={isActionPanelOpen}
                        inputParam_SetterIsPanelOpen={setIsActionPanelOpen}
                        inputParam_EditMode={true}
                        inputParam_SetFireGetLastActions={inputParam_SetFireGetLastActions}

                        inputParam_SelectedCauses={selectedCauses}
                        inputParam_SetterCauseActionList={setSelectedCauses}

                    />
                }
                    
                    <SidePanelFishboneSelection
                        isPanelOpen={isFishboneSelectionPanelOpen}
                        setterIsPanelOpen={setIsFishboneSelectionPanelOpen}
                        gapId={inputParam_GapAnalyzeId}
                        setterGAPElements={null}
                        elementId={inputParam_RevisionDataserie.id}
                    />
                    <SidePanelViewAllAction
                        inputParam_EditMode={false}
                        inputParam_IsPanelOpen={isViewAllActionPanelOpen}
                        inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                        inputParam_DataserieValueChartSelected={inputParam_DataserieValueChartSelected}
                        inputParam_GapRevisionId={inputParam_GapRevision !== null ? inputParam_GapRevision.id : null}
                        inputParam_SetterIsPanelOpen={setIsViewAllActionPanelOpen}
                    />
                    <DialogUsedCauseWarning
                        inputParam_IsDialogOpen={isDialogVisible}
                        inputParam_SetterIsDialogOpen={onReplaceCausesResponse}
                        inputParam_SetterDialogClose={onCloseCausesDialog}
                    /> 
                </>
            </Row>
}

Fishbone.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_GapRevision: PropTypes.object,
    inputParam_FishboneIndex: PropTypes.number.isRequired,
    inputParam_HasFishbone: PropTypes.bool.isRequired,
    inputParam_DataserieValueChartSelected: PropTypes.object,

    inputParam_CauseList: PropTypes.object,
    inputParam_DatinputParam_SetterCauseListaserieValueChartSelected: PropTypes.func,
};

export default Fishbone;